import React from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import EndorsementMotivationForm from '../../../components/forms/EndorsementMotivationForm';
import { useEndorsementMotivationById, useUpdateEndorsementMotivation } from '../../../hooks/useEndorsementMotivationApi';
import { useNavigate, useParams } from 'react-router-dom';

const EndorsementMotivationEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData } = useEndorsementMotivationById(id);
  const updateMutation = useUpdateEndorsementMotivation();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Endorsement Motivations', href: '/admin/endorsementmotivations' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      await updateMutation.mutateAsync({ id: id!, data });
      navigate('/admin/endorsementmotivations');
    } catch (error) {
      console.error('Error updating EndorsementMotivation:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/endorsementmotivations"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.EndorsementMotivation.Edit'
    >
        {entityData ? (
          <EndorsementMotivationForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/endorsementmotivations')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default EndorsementMotivationEdit;